import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider, createTheme } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from './widgets/ScrollToTop';
import RouteChangeTracker from './widgets/RouteChangeTracker';
import { HelmetProvider } from "react-helmet-async";
import { colors } from "./ui/tokens";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Font family is left at the MUI default on purpose: the site keeps its fonts.
// Only sizes, weights and spacing are tuned.
const theme = createTheme({
  palette: {
    primary: {
      main: colors.navyMid,
      light: "#F8F9FF",
      dark: colors.navy,
    },
    secondary: {
      main: colors.orange,
      dark: "#D08200",
    },
    text: {
      primary: colors.ink,
      secondary: colors.body,
    },
    background: {
      default: colors.paper,
    },
  },
  shape: { borderRadius: 10 },
  typography: {
    h1: {
      fontWeight: 700,
      fontSize: "clamp(2.05rem, 1.2rem + 3.6vw, 4.1rem)",
      lineHeight: 1.06,
      letterSpacing: "-0.025em",
    },
    h2: {
      fontWeight: 700,
      fontSize: "clamp(1.65rem, 1.1rem + 2.2vw, 2.75rem)",
      lineHeight: 1.12,
      letterSpacing: "-0.02em",
    },
    h3: {
      fontWeight: 700,
      fontSize: "clamp(1.3rem, 1rem + 1.2vw, 1.75rem)",
      lineHeight: 1.2,
      letterSpacing: "-0.01em",
    },
    h4: {
      fontWeight: 700,
      fontSize: "1.25rem",
      lineHeight: 1.3,
    },
    body1: { lineHeight: 1.7 },
    body2: { lineHeight: 1.6 },
    button: { textTransform: "none", fontWeight: 600, letterSpacing: 0 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, padding: "11px 22px", fontSize: "0.98rem" },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: { paddingLeft: 20, paddingRight: 20, "@media (min-width:600px)": { paddingLeft: 32, paddingRight: 32 } },
      },
    },
  },
});

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <ScrollToTop />
          <RouteChangeTracker />
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
